import React from 'react'

const DetailsSection: React.FC = ({ children }) => {
  return (
    <section className="border-b border-b-gray dark:border-b-gray-border-dm py-4">
      {children}
    </section>
  )
}

export default DetailsSection
